// FILE: components/Badge.tsx
// This component displays a small status descriptor.

import React from 'react';

export interface BadgeProps {
  variant?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info';
  children: React.ReactNode;
  className?: string;
}
export const Badge: React.FC<BadgeProps> = ({ variant = 'default', children, className = '' }) => {
  const variantStyles = {
    default: 'bg-bg-tertiary text-text-secondary dark:bg-dark-bg-tertiary dark:text-dark-text-secondary',
    primary: 'bg-brand-orange text-white',
    secondary: 'bg-brand-navy/10 text-brand-navy border border-brand-navy/20 dark:bg-dark-brand-navy/10 dark:text-dark-brand-navy dark:border-dark-brand-navy/20',
    info: 'bg-system-info-light text-system-info-dark border border-system-info-dark/30 dark:bg-system-info-dark-bg/40 dark:text-system-info-light-text dark:border-system-info-light-text/30',
    success: 'bg-system-success-light text-system-success-dark border border-system-success-dark/30 dark:bg-system-success-dark-bg/40 dark:text-system-success-light-text dark:border-system-success-light-text/30',
    warning: 'bg-system-warning-light text-system-warning-dark border border-system-warning-dark/30 dark:bg-system-warning-dark-bg/40 dark:text-system-warning-light-text dark:border-system-warning-light-text/30',
    error: 'bg-system-error-light text-system-error-dark border border-system-error-dark/30 dark:bg-system-error-dark-bg/40 dark:text-system-error-light-text dark:border-system-error-light-text/30',
  };
    return (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold ${variantStyles[variant!]} ${className}`}>
            {children}
        </span>
    );
};
